// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/transborder-customs-clearance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/transborder-customs-clearance/transborder-customs-clearance.js';

mount([g0]);
